import { Injectable, Output, EventEmitter } from '@angular/core';
import { InternetReviewMatrixResultView } from '../../../models/internetReviewMatrixResultView';
import { PageTitleRetrieval } from '../../../models/pageTitleRetrieval.model';
import _ from 'lodash-es';

@Injectable()
export class PageTitlesRetrievalSelectionService {
  @Output() itemsAdded = new EventEmitter();

  private dict = {};

  public addSelectedItemsForPageTitlesRetrieval(studyId: number, selectedItems: InternetReviewMatrixResultView[]): void {
    const toProcessItems = _.filter(selectedItems, function (i) {
      return !!i.companyWebSite || i.useSuggestedWebsite;
    });

    if (toProcessItems.length === 0) {
      return;
    }

    this.invalidateForStudy(studyId);

    const items = this.getItems(studyId);

    const newItems = _.map(toProcessItems, function (n) {
      return new PageTitleRetrieval(n.comparableID, n.companyName);
    });

    const forRetrieval = _.uniqBy(items.concat(newItems), 'id');

    this.dict[studyId] = forRetrieval;

    this.itemsAdded.emit();
  }

  public addSelectedItemForPageTitlesRetrieval(studyId: number, comparable: InternetReviewMatrixResultView): void {
    if (!comparable.companyWebSite && !comparable.useSuggestedWebsite) {
      return;
    }

    this.invalidateForStudy(studyId);

    const items = this.getItems(studyId);

    const newItem = new PageTitleRetrieval(comparable.comparableID, comparable.companyName);

    const forRetrieval = _.uniqBy(items.concat(newItem), 'id');

    this.dict[studyId] = forRetrieval;

    this.itemsAdded.emit();
  }

  public addNotificationItemsForPageTitlesRetrieval(studyId: number, comparableIds: Array<number>): void {
    const items = this.getItems(studyId);

    const newItems = _.map(comparableIds, function (id) {
      return new PageTitleRetrieval(id, null);
    });

    const forRetrieval = _.uniqBy(items.concat(newItems), 'id');

    this.dict[studyId] = forRetrieval;
  }

  public getItemsCount(studyId: number): number {
    return this.getItems(studyId).length;
  }

  public getItemsByStudyId(studyId: number): Array<PageTitleRetrieval> {
    const items = this.getItems(studyId);

    return items;
  }

  public getComparableIds(studyId: number): Array<number> {
    return _.map(this.getItems(studyId), 'id');
  }

  private invalidateForStudy(studyId: number) {
    this.dict[studyId] = [];
  }

  private getItems(studyId: number): Array<PageTitleRetrieval> {
    return !this.dict[studyId] ? [] : this.dict[studyId];
  }
}
